module.exports = __webpack_public_path__ + "img/mold.a36a795d.jpg";